import Req from '../../$axios';

const serviceModule = {
  // 获取任务列表
  getTaskList(params) {
    return Req(
      {
        url: 'tasks/relatedToMeTasksIndex',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 项目列表
  getProjectList(params) {
    return Req(
      {
        url: 'project/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 编辑任务
  editTask(params) {
    return Req(
      {
        url: 'task/updatetask/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除任务
  delTask(params) {
    return Req(
      {
        url: 'task/deletetask/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  relatedToMeProjectsIndex(params) {
    return Req(
      {
        url: 'project/relatedToMeProjectsIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getColorList(params) {
    return Req(
      {
        url: 'colorMark/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  setTodoTask(params) {
    return Req(
      {
        url: 'todo/save',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  todoUndoneIndex(params) {
    return Req(
      {
        url: 'todo/todoUndoneIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  todoCompletedIndex(params) {
    return Req(
      {
        url: 'todo/todoCompletedIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  todoUpdate(params) {
    return Req(
      {
        url: 'todo/update',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  todoDetail(params) {
    return Req(
      {
        url: 'todo/read',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  updateTodoSort(params) {
    return Req(
      {
        url: 'todo/updateTodoSort',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  deleteTodo(params) {
    return Req(
      {
        url: 'todo/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  relatedToMeUndoneTasksIndex(params) {
    return Req(
      {
        url: 'tasks/relatedToMeUndoneTasksIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  relatedToMeCompletedTasksIndex(params) {
    return Req(
      {
        url: 'tasks/relatedToMeCompletedTasksIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  exportRelatedToMeTasksList(params) {
    return Req(
      {
        url: 'tasks/exportRelatedToMeTasksList',
        method: 'get',
        isJSON: true,
        isFile: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
};
